import React, { useState, useRef, useEffect } from "react";
import theme from "../../../styles/theme";

const DropdownMenuList = ({
  icon,
  chevronIcon,
  label = "",
  items = [], // [{ icon, label, link }]
  position = "right",
  direction = "bottom",
  offsetX = 0,
  iconSize = 20,       
  chevronSize = 20,    
 

}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  // Fermer le menu si clic extérieur
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigate = (link) => {
    if (link) window.location.href = link;
    setOpen(false);
  };

  return (
    <div ref={menuRef} style={{ position: "relative", display: "inline-block" }}>
      {/* En-tête fixe avec icône, label et chevron */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          transition: "background-color 0.2s",
          zIndex: 9999,
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "5px 8px",
            background: theme.colors.background.menulist,
            borderRadius: "4px",
            border: `1px solid ${theme.colors.borders.menuList}`,
          }}
        >
          {icon && <img src={icon} alt="icon" style={{ width: iconSize, height: iconSize }} />}
          {label && <span style={{ fontWeight: theme.fontWeights.md }}>{label}</span>}
          {chevronIcon && <img src={chevronIcon} alt="chevron" style={{ width: chevronSize, height: chevronSize }} />}
        </span>
      </div>

      {/* Panneau d'items */}
      {open && (
        <div
          style={{
            position: "absolute",
            [direction === "top" ? "bottom" : "top"]: "100%",
            marginTop: 4,
            minWidth: "160px",
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.xl,
            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
            zIndex: 9999,
            overflow: "hidden",
            left: offsetX ? `${offsetX}px` : 0,
          }}
        >
          {items.map((item, idx) => (
            <div
              key={idx}
              onClick={() => handleNavigate(item.link)}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.md,
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                backgroundColor: theme.colors.background.surface,
              }}
            >
              {item.icon && (
                <img src={item.icon} alt="" style={{ width: 16, height: 16, objectFit: "contain" }} />
              )}
              <span
                style={{
                  color: hoverIndex === idx ? theme.colors.primary : theme.colors.text.third,
                  transition: "color 0.4s",
                  fontSize: theme.fontSizes.sm,
                }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenuList;

